<template>
    <div>
			<el-table size="medium" :data="tableData" header-cell-class-name="table_header"
								:stripe="true" :height="400" @selection-change="customerSelectChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="name" label="姓名" >
				</el-table-column>
				<el-table-column prop="phone" label="手机号">
				</el-table-column>
			</el-table>
			<div style="text-align:right;line-height: 40px;padding-top: 5px;background:#fff;">
				<el-pagination @current-change="currentPageChangeHandler" background layout="total,prev, pager, next" :total="total" :page-size="pageSize">
				</el-pagination>
			</div>
			<div style="text-align: left;margin-left: 20px;">
				<el-button type="primary" @click="submit()" :disabled="selectCustomers.length==0" >确 定</el-button>
			</div>
		</div>
</template>

<script>
	import config from "../../../config/global.js";
	import axios from "axios"

    export default {
    	name: "choose-customer",
			data(){
        	return {
						selectCustomers:[],
						tableData: [],
						searchKey:'',
						total:0,
						pageSize:200,
						currentPageIndex:1
					}
			},
			methods:{
				//获取客户列表
				queryCustomers:function () {
					var start = Math.max(0,(this.currentPageIndex-1)*this.pageSize);
					var size = this.pageSize;
					axios({
						method: 'post',
						url:config.host+'/backend/customer/list.json',
						data:{start,size,name:this.searchKey}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.tableData = response.data.items
						this.total = response.data.total
					})
						.catch((error)=>{
							console.log(error)
						})
				},
				//勾选用户
				customerSelectChange:function (val) {
						this.selectCustomers = val;
				},
				//页码变化时
				currentPageChangeHandler:function (val) {
					this.currentPageIndex = val;
					this.queryCustomers();
				},
				submit:function () {
					if(this.selectCustomers.length == 0 ){
						this.$alert("请先选择客户", '提示', {
							confirmButtonText: '确定'
						});
						return;
					}
					this.$emit('onconfirm',this.selectCustomers);
				}
			},
			mounted:function(){
        	this.queryCustomers();
			}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/customer/ChooseCustomer.vue